import React, { useEffect, useState } from 'react';
import { ProfileDataType, ProfileField } from '../../../types/profile';
import { createEmptyField } from '../../../utils/formatUtils';
import ProfileFieldForm from '../profile/ProfileFieldForm';

interface InlineFieldInputProps {
  dataType: ProfileDataType;
  onFieldChange: (field: ProfileField) => void;
  field?: ProfileField;
}

export default function InlineFieldInput({ dataType, onFieldChange, field }: InlineFieldInputProps): JSX.Element {
  const [currentField, setCurrentField] = useState<ProfileField>(field || createEmptyField(dataType));

  useEffect(() => {
    if (field) {
      setCurrentField(field);
    } else {
      setCurrentField(createEmptyField(dataType));
    }
  }, [field, dataType]);

  const handleFieldChange = (updatedField: ProfileField): void => {
    setCurrentField(updatedField);
    onFieldChange(updatedField);
  };

  return (
    <div className="my-1 flex flex-col gap-2">
      <ProfileFieldForm field={currentField} setField={handleFieldChange} canBeEmpty validate={false} />
    </div>
  );
}
